export default __webpack_public_path__ + "static/media/page4.4c81a903.jpg";